import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Titles } from "../../components/Titles";
import { TabPanel } from "../../components/shared/tabpanel";
import { Subsections } from "./components/subsections";
import { ProminentClients } from "../../components/prominent-clients";
import { useTranslations } from "../../hooks/use-translations";
import { useLanguage } from "../../hooks/use-language";

/**
 * Este componente tab panel carga la tienda para instituciones
 */
export const PlanInstituciones = () => {
    /* const [urlLang, setURLLang] = useState('es'); */
    const lang = useLanguage();
    const textos = useTranslations({ section: "tienda_makemake", lang: lang });

    const history = useHistory();
    const location = useLocation();
    /* const tabPanelIds = {
        citaES: `/tienda/institucional/es/cita`,
        citaEN: `/tienda/institucional/en/cita`,
        demoES: "/tienda/institucional/es/demo",
        demoEN: "/tienda/institucional/en/demo",
        brochureES: "/tienda/institucional/es/brochure",
        brochureEN: "/tienda/institucional/en/brochure",
        contactanosES: "/tienda/institucional/es/contactanos",
        contactanosEN: "/tienda/institucional/en/contactanos",
    };
 */
    const tabPanelIds = {
        cita: `/tienda/institucional/cita`,
        demo: "/tienda/institucional/demo",
    };

    const ariaLabel = {
        en: "Panel of tabs of Tienda Institucional",
        es: "Panel de tabs de la Tienda Institucional",
    };

    /*define cual es el tab panel (tienda) que se debe mostrar en pantalla.*/
    const [currentTabPanel, setCurrentTabPanel] = useState(tabPanelIds);

    useEffect(() => {
        /* const langAccordingUrl = location.pathname.includes('/es/') ? "es" : "en";
        setURLLang(langAccordingUrl) */
        /**
            dependiendo de la ruta del navegador si coincide con algún id 
            de los tab panel, entonces muestra el panel respectivo, 
            si no es así mostrará por defecto el de tienda institucional
         */
        if (Object.values(tabPanelIds).includes(location.pathname)) {
            setCurrentTabPanel(location.pathname);
        } else {
            setCurrentTabPanel(tabPanelIds.citaES);
        }
    }, [location]);

    /**
     * cambia la ruta actual, debería llevar a la ruta de una tienda especifica.
     * Si la ruta coincide con el id de algún tab panel se mostrará ese panel automaticamente,
     * de no existir se mostrará por defecto el tab de tienda institucional.
     */
    const tabPanelNavigateTo = (path) => {
        history.push(path);
    };


    return (
        <>
            <Titles
                hexBackground="#FFD103"
                color="onprimary--color"
                title={textos?.tienda?.instituciones?.titulo || 'Contáctanos'}
                darkShapes
                description={textos?.tienda?.instituciones?.subtitulo || 'MakeMake ofrece suscripciones a planes de lectura para colegios y bibliotecas.'}
            />
            <div className="plan-instituciones">
                <div className="container instituciones-content">
                    <div>
                        <div>
                            <TabPanel.Root
                                value={currentTabPanel}
                                onValueChange={tabPanelNavigateTo}
                                className="d-lg-flex"
                            >
                                <TabPanel.List className="wrapper-tabs col-lg-4 col-xl-3 pt-lg-5 px-0" ariaLabel={ariaLabel[lang]}  >
                                    <TabPanel.Trigger
                                        value={tabPanelIds.cita}
                                        className={`focusable-red tab mt-5 ${
                                            currentTabPanel === tabPanelIds.cita ? "current" : ""
                                        }`}
                                    >
                                        <>
                                            {textos?.tabpanel?.institucional1 || "Agenda una cita"}
                                            {currentTabPanel === tabPanelIds.cita && (
                                                <Icon
                                                    icon="iconamoon:arrow-right-2-bold"
                                                    width={25}
                                                    className="d-none d-lg-block"
                                                />
                                            )}
                                        </>
                                    </TabPanel.Trigger>

                                    <TabPanel.Trigger
                                        value={tabPanelIds.demo}
                                        className={`focusable-red tab ${
                                            currentTabPanel === tabPanelIds.demo ? "current" : ""
                                        }`}
                                    >
                                        <>
                                            {textos?.tabpanel?.institucional2 || "Solicita un demo"}
                                            {currentTabPanel === tabPanelIds.demo && (
                                                <Icon
                                                    icon="iconamoon:arrow-right-2-bold"
                                                    width={25}
                                                    className="d-none d-lg-block"
                                                />
                                            )}
                                        </>
                                    </TabPanel.Trigger>
                                </TabPanel.List>

                                <TabPanel.Content
                                    value={tabPanelIds.cita}
                                    className="col-lg-8 col-xl-9 mt-5 mt-lg-0 instituciones-panel"
                                >
                                    <Subsections.Cita />
                                </TabPanel.Content>

                                <TabPanel.Content
                                    value={tabPanelIds.demo}
                                    className="col-lg-8 col-xl-9 mt-5 mt-lg-0 instituciones-panel"
                                >
                                    <Subsections.Demo />
                                </TabPanel.Content>
                            </TabPanel.Root>
                        </div>

                    </div>
                </div>
                
                <ProminentClients />

            </div>
        </>
    )
}